import styled from '@emotion/styled';

const LogoAnchor = styled.a`
    letter-spacing: 2px;
    color: #000;
    font-size: 25px;
    font-weight: 900;
    font-family: Trebuchet MS,Arial,Helvetica,sans-serif;
    text-decoration: none;
    padding: 0;
    opacity: .7;
    &:hover{
      text-decoration: none;
      color: #000;
    }
`;

export default LogoAnchor;
